__turbopack_context__.v({
  "body": "CatalogAdminToolbar-module__OIs_Bq__body",
  "card": "CatalogAdminToolbar-module__OIs_Bq__card",
  "cardDanger": "CatalogAdminToolbar-module__OIs_Bq__cardDanger",
  "cardDisabled": "CatalogAdminToolbar-module__OIs_Bq__cardDisabled",
  "cardHint": "CatalogAdminToolbar-module__OIs_Bq__cardHint",
  "cardIcon": "CatalogAdminToolbar-module__OIs_Bq__cardIcon",
  "cardLabel": "CatalogAdminToolbar-module__OIs_Bq__cardLabel",
  "cards": "CatalogAdminToolbar-module__OIs_Bq__cards",
  "catalogInfo": "CatalogAdminToolbar-module__OIs_Bq__catalogInfo",
  "catalogInfoBody": "CatalogAdminToolbar-module__OIs_Bq__catalogInfoBody",
  "catalogInfoIcon": "CatalogAdminToolbar-module__OIs_Bq__catalogInfoIcon",
  "catalogInfoLabel": "CatalogAdminToolbar-module__OIs_Bq__catalogInfoLabel",
  "catalogInfoMeta": "CatalogAdminToolbar-module__OIs_Bq__catalogInfoMeta",
  "catalogInfoSymbol": "CatalogAdminToolbar-module__OIs_Bq__catalogInfoSymbol",
  "closeBtn": "CatalogAdminToolbar-module__OIs_Bq__closeBtn",
  "footerNote": "CatalogAdminToolbar-module__OIs_Bq__footerNote",
  "footerNoteIcon": "CatalogAdminToolbar-module__OIs_Bq__footerNoteIcon",
  "homepageInfo": "CatalogAdminToolbar-module__OIs_Bq__homepageInfo",
  "homepageInfoBody": "CatalogAdminToolbar-module__OIs_Bq__homepageInfoBody",
  "homepageInfoIcon": "CatalogAdminToolbar-module__OIs_Bq__homepageInfoIcon",
  "panel": "CatalogAdminToolbar-module__OIs_Bq__panel",
  "permissionBadge": "CatalogAdminToolbar-module__OIs_Bq__permissionBadge",
  "permissionBadge_full": "CatalogAdminToolbar-module__OIs_Bq__permissionBadge_full",
  "permissionBadge_owner": "CatalogAdminToolbar-module__OIs_Bq__permissionBadge_owner",
  "permissionBadge_redactor": "CatalogAdminToolbar-module__OIs_Bq__permissionBadge_redactor",
  "permissionBadge_restricted": "CatalogAdminToolbar-module__OIs_Bq__permissionBadge_restricted",
  "slideDown": "CatalogAdminToolbar-module__OIs_Bq__slideDown",
});
